export interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
}

interface HapticFeedback {
  impactOccurred(style: "light" | "medium" | "heavy" | "rigid" | "soft"): void;
}

export interface TelegramWebApp {
  initData: string;
  initDataUnsafe: {
    user?: TelegramUser;
    start_param?: string;
  };
  colorScheme: "light" | "dark";
  themeParams: Record<string, string>;
  HapticFeedback?: HapticFeedback;
  ready(): void;
  expand(): void;
  disableVerticalSwipes?(): void;
  enableVerticalSwipes?(): void;
  openInvoice?(
    url: string,
    callback?: (status: "paid" | "cancelled" | "failed" | "pending") => void,
  ): void;
  shareMessage?(msgId: string, callback?: (sent: boolean) => void): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp: TelegramWebApp };
  }
}

export const tg: TelegramWebApp | undefined = window.Telegram?.WebApp;

/** The Mini App start parameter, from initData or the launch URL hash. */
export function startParam(): string {
  const fromTg = tg?.initDataUnsafe.start_param;
  if (fromTg) return fromTg;
  try {
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    return hash.get("tgWebAppStartParam") ?? "";
  } catch {
    return "";
  }
}

/** The wall to show: from the deep-link start_param, or a URL fallback for dev. */
export function targetSlug(): string {
  const sp = startParam();
  if (sp && !sp.startsWith("claim_")) return sp;
  const fromUrl = new URLSearchParams(window.location.search).get("startapp");
  if (fromUrl) return fromUrl;
  // No deep-link target -> show the current user's own wall.
  const me = tg?.initDataUnsafe.user;
  if (me) return me.username ?? String(me.id);
  return "demo";
}

/** The current user's own wall slug. */
export function mySlug(): string {
  const me = tg?.initDataUnsafe.user;
  return me ? (me.username ?? String(me.id)) : "demo";
}

export function haptic(style: "light" | "medium" = "light"): void {
  tg?.HapticFeedback?.impactOccurred(style);
}
